import { Eye, Users2, BarChart3, AlertOctagon, Workflow, Gauge } from "lucide-react";

export const EOS_WORLDWIDE_URL = "https://www.eosworldwide.com";
export const EOS_PROFILE_URL = "https://implementer.eosworldwide.com/carlos-garcin/";

export const SIX_COMPONENTS = [
  { icon: Eye, name: "Visión", text: "Todos alineados sobre hacia dónde va la empresa y cómo pretende llegar." },
  { icon: Users2, name: "Personas", text: "Las personas correctas en los puestos correctos." },
  { icon: BarChart3, name: "Datos", text: "Un pequeño conjunto de números que permite conocer objetivamente el pulso del negocio." },
  { icon: AlertOctagon, name: "Asuntos", text: "Identificar los problemas reales, discutirlos abiertamente y resolverlos de raíz." },
  { icon: Workflow, name: "Procesos", text: "Definir y seguir una forma consistente de hacer las cosas importantes." },
  { icon: Gauge, name: "Tracción", text: "Convertir la visión en prioridades, responsables, reuniones efectivas y ejecución." },
];

export const CONTEXT_BULLETS = [
  "Menos decisiones dependiendo del gerente general.",
  "Mayor claridad entre áreas, prioridades y responsables.",
  "Una forma consistente de ejecutar y resolver problemas.",
];

export const SIGNALS = [
  "El dueño o gerente general sigue siendo cuello de botella.",
  "Existen demasiadas prioridades simultáneas.",
  "Las responsabilidades entre líderes no están completamente claras.",
  "Hay estrategia, pero cuesta convertirla en ejecución.",
  "Las reuniones consumen tiempo y resuelven poco.",
  "Los mismos problemas importantes vuelven una y otra vez.",
];

export const DIFFERENTIALS = [
  {
    title: "Experiencia ejecutiva real",
    text: "He estado del otro lado de la mesa y conozco la presión de dirigir equipos y hacer que una empresa funcione.",
  },
  {
    title: "Implementación práctica",
    text: "Mi foco es llevar las herramientas de EOS a la realidad de tu empresa, sin agregar complejidad innecesaria.",
  },
  {
    title: "Trabajo directamente contigo",
    text: "No delego la implementación. Trabajo personalmente contigo y con tu equipo de liderazgo.",
  },
];

export const STEPS = [
  { title: "Conversamos 15 minutos", text: "Me cuentas dónde está hoy tu empresa y qué están tratando de resolver." },
  { title: "Conocen EOS", text: "Si existe un posible calce, nos reunimos durante 90 minutos con tu equipo de liderazgo para mostrarles cómo funciona EOS, sus herramientas y la forma de implementación." },
  { title: "Ustedes deciden", text: "Con toda la información sobre la mesa, el equipo decide si EOS hace sentido para la empresa." },
];

export function buildFaqs(c) {
  return [
    {
      id: "que-es-eos",
      q: "¿Qué es EOS?",
      a: "EOS — Entrepreneurial Operating System® — es un sistema de gestión para empresas emprendedoras que ayuda a sus equipos de liderazgo a lograr mayor claridad, disciplina y ejecución.",
    },
    { id: "implementer-local", q: `¿Hay un Professional EOS Implementer en ${c.name}?`, a: c.implementerFaqAnswer },
    { id: "ubicacion", q: c.locationFaq.q, a: c.locationFaq.a },
    {
      id: "eos-virtual",
      q: "¿EOS se puede implementar de forma virtual?",
      a: "Sí. EOS puede implementarse tanto de forma presencial como virtual. Trabajo regularmente en ambas modalidades, y durante una misma implementación incluso pueden combinarse sesiones presenciales y virtuales según lo que funcione mejor para el equipo de liderazgo.",
    },
    {
      id: "tipo-de-empresas",
      q: "¿Para qué tipo de empresas sirve EOS?",
      a: "EOS está pensado principalmente para empresas emprendedoras con un equipo de liderazgo que quiere crecer y operar mejor.",
    },
    {
      id: "eos-es-software",
      q: "¿EOS es un software?",
      a: "No. EOS es un sistema de gestión. Sus herramientas pueden gestionarse con papel, documentos, planillas o plataformas tecnológicas.",
    },
    {
      id: "es-consultoria",
      q: "¿Implementar EOS es contratar una consultoría empresarial?",
      a: "No exactamente. El Implementador enseña y facilita EOS, pero las decisiones estratégicas y operativas siguen perteneciendo al equipo de liderazgo.",
    },
    {
      id: "eos-y-estrategia",
      q: "¿EOS reemplaza la estrategia de la empresa?",
      a: "No. EOS ayuda al equipo de liderazgo a clarificar su propia visión y convertirla en ejecución.",
    },
    {
      id: "primer-paso",
      q: "¿Cuál es el primer paso para implementar EOS?",
      a: "El primer paso puede ser una conversación de 15 minutos para determinar si existe un posible calce entre EOS y las necesidades de la empresa.",
    },
  ];
}
